<template>
  <m-layout-mask>
    <m-layout class="left-sidebar-layout" :class="{ compact: compactSidebar }">
      <m-scrollbar>
        <result-menu />
      </m-scrollbar>
    </m-layout>
    <m-layout grow>
      <m-scrollbar id="result-scrollbar">
        <result-list />
      </m-scrollbar>
    </m-layout>
  </m-layout-mask>
</template>

<script>
import MLayoutMask from '@/components/layouts/MLayoutMask'
import MLayout from '@/components/layouts/MLayout'
import MScrollbar from '@/components/MScrollbar'
import MWidgetHead from '@/components/widget/MWidgetHead'
import MHideToggler from '@/components/buttons/MHideToggler'
import ResultMenu from '@/components/results/menu/Menu'
import ResultList from '@/components/results/list/List'

export default {
  components: { MLayoutMask, MLayout, MScrollbar, MWidgetHead, MHideToggler, ResultMenu, ResultList },
  data () {
    return {
      compactSidebar: false
    }
  },
  watch: {
    '$route' (to, from) {
      let scrollbar = document.querySelector('#result-scrollbar')
      if (scrollbar) scrollbar.scrollTop = 0
      this.$store.dispatch('results/GET_OVERVIEW', this.$route.params)
    },
    '$i18n.locale' (to, from) {
      this.$store.dispatch('results/GET_MENU', this.$route.params.date)
      this.$store.dispatch('results/GET_OVERVIEW', this.$route.params)
    }
  },
  mounted () {
    this.$store.dispatch('results/GET_OVERVIEW', this.$route.params)
  },
  beforeDestroy () {
    this.$store.commit('results/CLEAR')
  }
}
</script>

<style scoped>
.result-widget-head { margin-left: 10px; }
</style>



// WEBPACK FOOTER //
// src/components/results/Results.vue